module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rain1-faa5b85a01a4bbc1dbeb95b987240104.svg";